import { ChevronDownIcon } from '@shared/components/Icons';
import { ProfileIconImage } from '@shared/components/Images';
import clsx from 'clsx';
import { url } from 'constants/urls';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

type NavbarAuthButtonProps = {
  isLoggedIn: boolean;
  redirectLoginUrl: string;
  toggleMobileMenu: VoidFunction;
}

export const NavbarAuthButton: FC<NavbarAuthButtonProps> = ({
  isLoggedIn,
  redirectLoginUrl,
  toggleMobileMenu,
}) => {
  const { t } = useTranslation();

  return (
    <li
      className={clsx(
        'border-separator flex h-[64px] border-b font-bold transition-all duration-200 hover:brightness-125 lg:border-none',
        !isLoggedIn && 'border-b-0',
      )}
    >
      <Link
        to={isLoggedIn ? url.redirectDashboard : redirectLoginUrl}
        target="_blank"
        rel="noopener noreferrer"
        onClick={() => toggleMobileMenu()}
        className="font-poppins flex w-full items-center text-[17.5px] tracking-normal"
      >
        {isLoggedIn ? (
          <div className="flex flex-row items-center gap-2">
            <ProfileIconImage className="h-[24px] w-[27px] lg:size-[40px]" />
            <div className="text-[17.5px] font-black lg:hidden">
              {t('navbar.dashboard')}
            </div>
          </div>
        ) : (
          <div className="hover:text-neon_yellow flex w-full flex-row items-center justify-between uppercase tracking-wide lg:text-[15.5px] xl:text-[17.5px]">
            <div>{t('navbar.signIn')}</div>
            {/* TODO: replace with the correct icon right arrow */}
            <ChevronDownIcon className="size-[20px] -rotate-90 sm:hidden" />
          </div>
        )}
      </Link>
    </li>
  );
};
